// Wedding mini-site: richly differentiated themes + default modular sections.
export const SITE_THEMES = {
  botanical: {
    name: "Botanique", mood: "Végétal, frais, naturel",
    heading: "'Cormorant Garamond', serif", body: "'Montserrat', sans-serif",
    bg: "#F3F5EF", surface: "#FFFFFF", text: "#2F3A29", muted: "#6c7563", accent: "#5f7358",
    accentText: "#FFFFFF", hero: "overlay", radius: "0px", divider: "leaf_branch", nav: "center", caps: true, weight: 600,
  },
  editorial: {
    name: "Editorial", mood: "Magazine, épuré, contrasté",
    heading: "'Playfair Display', serif", body: "'Montserrat', sans-serif",
    bg: "#F4F0EA", surface: "#FFFFFF", text: "#1C1B1A", muted: "#6b6660", accent: "#111110",
    accentText: "#FFFFFF", hero: "split", radius: "0px", divider: "line", nav: "left", caps: true, weight: 700,
  },
  romantic: {
    name: "Romantique", mood: "Floral, tendre, script",
    heading: "'Great Vibes', cursive", body: "'Cormorant Garamond', serif",
    bg: "#FBF3F3", surface: "#FFFFFF", text: "#5A4650", muted: "#957d86", accent: "#C77E8E",
    accentText: "#FFFFFF", hero: "overlay", radius: "28px", divider: "rose_divider", nav: "center", caps: false, weight: 400,
  },
  minimal: {
    name: "Minimaliste", mood: "Clair, aéré, moderne",
    heading: "'Montserrat', sans-serif", body: "'Montserrat', sans-serif",
    bg: "#FFFFFF", surface: "#FAFAF8", text: "#1C1B1A", muted: "#8a847d", accent: "#1C1B1A",
    accentText: "#FFFFFF", hero: "solid", radius: "10px", divider: "dots_divider", nav: "center", caps: true, weight: 300,
  },
  chateau: {
    name: "Château", mood: "Classique, doré, formel",
    heading: "'Bodoni Moda', serif", body: "'EB Garamond', serif",
    bg: "#F7F2E8", surface: "#FFFFFF", text: "#3A2E20", muted: "#8a7550", accent: "#B8860B",
    accentText: "#3A2E20", hero: "framed", radius: "4px", divider: "flourish", nav: "center", caps: true, weight: 500,
  },
  blacktie: {
    name: "Black Tie", mood: "Nocturne, doré, luxueux",
    heading: "'Bodoni Moda', serif", body: "'Montserrat', sans-serif",
    bg: "#111113", surface: "#1a1a1d", text: "#F2F0EC", muted: "#a29c90", accent: "#C9A227",
    accentText: "#111113", hero: "overlay", radius: "0px", divider: "flourish", nav: "center", caps: true, weight: 500,
  },
  coastal: {
    name: "Riviera", mood: "Lumineux, terracotta, chaleureux",
    heading: "'Playfair Display', serif", body: "'Montserrat', sans-serif",
    bg: "#FBF3E9", surface: "#FFFFFF", text: "#6b3f2a", muted: "#a07a5c", accent: "#C56B3E",
    accentText: "#FFFFFF", hero: "framed", radius: "18px", divider: "leaf_divider", nav: "left", caps: false, weight: 600,
  },
};

export const SECTION_META = {
  home: { label: "Accueil", fixed: true },
  story: { label: "Notre histoire" },
  schedule: { label: "Programme" },
  locations: { label: "Lieux" },
  accommodations: { label: "Hébergements" },
  practical: { label: "Infos pratiques" },
  gallery: { label: "Galerie" },
  faq: { label: "FAQ" },
  rsvp: { label: "RSVP", fixed: true },
};
export const SECTION_ORDER = ["home", "story", "schedule", "locations", "accommodations", "practical", "gallery", "faq", "rsvp"];

export function defaultSite(w = {}) {
  return {
    order: [...SECTION_ORDER],
    sections: {
      home: { enabled: true, eyebrow: "Nous nous marions", title: w.names || "Vos prénoms",
        date: w.wedding_date || "", city: w.city || "", photo: "" },
      story: { enabled: true, title: "Notre histoire",
        text: "Racontez votre rencontre, votre demande, ce qui vous rend uniques… vos invités adorent ces détails.", photo: "" },
      schedule: { enabled: true, title: "Programme de la journée", items: [
        { time: "15:00", title: "Cérémonie", desc: "", location: w.city || "" },
        { time: "16:30", title: "Vin d'honneur", desc: "", location: "" },
        { time: "19:00", title: "Dîner & soirée", desc: "", location: "" },
      ] },
      locations: { enabled: true, title: "Les lieux", items: [
        { name: "Lieu de réception", address: w.city || "", desc: "", mapUrl: "" },
      ] },
      accommodations: { enabled: false, title: "Où dormir", items: [
        { name: "Hôtel recommandé", desc: "À quelques minutes du lieu.", url: "", note: "" },
      ] },
      practical: { enabled: true, title: "Infos pratiques", blocks: [
        { title: "Dress code", text: "Tenue de ville élégante." },
        { title: "Parking", text: "Parking disponible sur place." },
      ] },
      gallery: { enabled: false, title: "Galerie", photos: [] },
      faq: { enabled: true, title: "Questions fréquentes", items: [
        { q: "Puis-je venir accompagné·e ?", a: "Merci de vous référer à votre invitation nominative." },
        { q: "Les enfants sont-ils les bienvenus ?", a: "" },
      ] },
      rsvp: { enabled: true, title: "Confirmez votre présence",
        text: "Nous serions ravis de vous compter parmi nous. Merci de répondre avant la date indiquée sur votre invitation.", deadline: "" },
    },
  };
}
